import EventEmitter from "base/EventEmitter";
import $ from "jquery";

class Modal extends EventEmitter {

    constructor(settings = {}) {
        super();
        Modal.init();

        this.settings = $.extend({}, Modal.DEFAULT_SETTINGS, settings);
        this.shown = false;
        this.built = false;
        Modal.modals.push(this);

        this._escHandle = this._escHandle.bind(this);
        this._backgroundHandle = this._backgroundHandle.bind(this);

        this.$content = $("<div>");
    }

    on() {
        if (arguments.length === 2 || 'boolean' === typeof arguments[2]) {
            return super.on.apply(this, arguments);
        }

        this.buildElement();
        this.$element.on.apply(this.$element, arguments);

        return this;
    }

    off() {
        if (arguments.length === 2) return super.off.apply(this, arguments);

        this.buildElement();
        this.$element.off.apply(this.$element, arguments);

        return this;
    }

    setContent($content) {
        if (Array.isArray($content)) {
            $content = eotwJSXFactory('div', null, [$content]);
        }

        this.$content = $content;
        if (this.built) {
            this.$element.find(".js-content").html(this.$content);
        }
        this.update();
        return this;
    }

    update() {
        if (!this.shown) return;
        this.buildElement();

        this.$element.attr("class", this.settings.baseClass + " " + this.settings.class + " " + this.settings.baseClass + "--shown");
    }

    show() {
        if (this.shown) return;

        this.shown = true;
        this.update();

        Modal.hideAllExcept(this);
        this.$element.addClass(this.settings.baseClass + "--shown");

        Modal.shownModals.push(this);
        Modal.checkBackground();
        this.emit("show");

        if (this.settings.escClose) {
            $("body").on("keyup", this._escHandle);
        }
        if (this.settings.backgroundClose) {
            $("." + Modal.DEFAULT_SETTINGS.baseClass + "-wrap").on("click", this._backgroundHandle);
        }
        if (this.settings.closeButton) {
            this.$element.on("click", ".js-close-btn, .js-close-modal", () => {
                if (!this.emit("close")) return false;
                this.hide();
                return false;
            });
        }

        return this;
    }

    _escHandle(e) {
        if (e.which === 27) {
            this.hide();
            this.emit("cancel");
            return false;
        }
    }

    _backgroundHandle(e) {
        let $target = $(e.target);
        if ($target.is("." + Modal.DEFAULT_SETTINGS.baseClass + "-wrap")) {
            if (!this.emit("close")) return;
            this.hide();
            this.emit("cancel");
        }
    }

    hide() {
        if (!this.shown || !this.built) return;
        this.shown = false;
        if (this.emit("hide", {}) === false) {
            this.shown = true;
            return;
        }

        this.$element.removeClass(this.settings.baseClass + "--shown");
        Modal.shownModals = Modal.shownModals.filter((modal) => modal !== this);
        Modal.checkBackground();
        $("body").off("keyup", this._escHandle);
        $("." + Modal.DEFAULT_SETTINGS.baseClass + "-wrap").off("click", this._backgroundHandle);
        if (this.settings.closeButton) {
            this.$element.off("click", ".js-close-btn");
        }

        if (this.settings.destroyOnClose) {
            this.destroy();
        }
        return this;
    }

    buildElement() {
        if (this.built) return;
        this.built = true;

        this.$element = eotwJSXFactory('div', {class: this.settings.baseClass}, [
            this.settings.closeButton ? eotwJSXFactory('button', {class: this.settings.baseClass + "__close-btn js-close-btn"}, [
                eotwJSXFactory('span', {class: this.settings.baseClass + "__close-btn__icon"}

                )
            ]) : [],
            eotwJSXFactory('div', {class: this.settings.baseClass + "__content js-content"}, [this.$content])
        ]);

        this.$element.find("." + this.settings.baseClass + "__close-btn__icon").html("<svg><use xmlns:xlink=\"http://www.w3.org/1999/xlink\" xlink:href=\"" + window.CONFIG.adminBuildUrl + "base/icons.svg#close\"/></svg>");

        $("." + Modal.DEFAULT_SETTINGS.baseClass + "-wrap").append(this.$element);

        this.emit("built");
    }

    destroy() {
        if (this.destroyed) return;

        this.hide();
        if (this.emit("destroy", {}) === false) return;

        Modal.modals = Modal.modals.filter((modal) => modal !== this);
        if (this.built) {
            this.$element.remove();
        }
        super.destroy();

        this.built = false;
        this.$element = eotwJSXFactory('div');
    }

    static init() {
        if (Modal.initialised === true) {
            return;
        }
        Modal.initialised = true;

        $("body").append($("<div>").addClass(Modal.DEFAULT_SETTINGS.baseClass + "-wrap"));
    }

    static hideAll() {
        Modal.hideAllExcept(null);
    }

    static hideAllExcept(modal) {
        for (let _modal of this.shownModals) {
            if (_modal !== modal) {
                _modal.hide();
            }
        }
    }

    static checkBackground() {
        $("body").toggleClass(Modal.DEFAULT_SETTINGS.baseClass + "-visible", Modal.shownModals.length > 0);
    }
}

Modal.shownModals = [];
Modal.modals = [];
Modal.initialised = false;

Modal.DEFAULT_SETTINGS = {
    "class": "",
    "closeButton": true,
    "backgroundClose": true,
    "escClose": true,
    "destroyOnClose": false,
    "baseClass": "admin-modal",
};

export default Modal;

